<template>
  <chemistry-touch-limit :initialUrl='$serviceAPI.getBiologicalTouchLimitInitial' :touchLimitUrl='$serviceAPI.findBiologicalTouchLimit'></chemistry-touch-limit>
</template>

<script>
  import chemistryTouchLimit from './chemistryTouchLimit.vue'
  export default{
    data(){
      return{

      }
    },
    created() {
    },
    methods:{

    },
    components:{
      chemistryTouchLimit
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/biologicalTouchLimit.vue